/**
 * Utility functions for calculating counts in list components
 */

/**
 * Calculate policy counts by category for PolicyList and BalanceList
 * @param {Array} policies - Array of policy objects
 * @returns {Object} Object with counts for each category
 */
export const getPolicyCountsByCategory = (policies) => {
  const counts = {
    motor: 0,
    'non-motor': 0,
    life: 0
  };

  policies.forEach(policy => {
    // Exclude new leads from counts
    if (policy.status === "New Lead") return;

    const category = policy.policyCategory;
    if (category === "motor") {
      counts.motor++;
    } else if (category === "non-motor") {
      counts['non-motor']++;
    } else if (policy.policyCategoryType === "life") {
      counts.life++;
    }
  });

  return counts;
};

/**
 * Calculate client counts by status for ClientList
 * @param {Array} clients - Array of client objects
 * @returns {Object} Object with counts for customers and new leads
 */
export const getClientCountsByStatus = (clients) => {
  const counts = {
    customers: 0,
    'new-leads': 0
  };

  clients.forEach(client => {
    if (client.status === "New Lead") {
      counts['new-leads']++;
    } else {
      counts.customers++;
    }
  });

  return counts;
};
